<template lang="html">
<b-td @mouseover="mouseOver" @mouseleave="mouseLeave" class="text-center" style="vertical-align: middle">
    <template v-if="loaded">
        <template v-if="filteredBookings.length > 0">
            <template v-if="content.cc.campaignId">
                <b-button v-if="content.isTag" size="sm" @click="$emit('triggerModal', 'manageCampaignTag', content.cc, content.dc)" :variant="running ? 'success' : 'warning'">BOOKED</b-button>
                <b-button v-else size="sm" @click="$emit('triggerModal', 'manageCampaign', content.cc, content.dc)" :variant="running ? 'success' : 'warning'">BOOKED <b-badge v-if="filteredBookings.length > 1" variant="light">{{ filteredBookings.length }}</b-badge></b-button>
            </template>
            <template v-else>
                <b-button v-if="content.isTag" size="sm" @click="$emit('triggerModal', 'manageSourceTag', content.cc, content.dc)" :variant="running ? 'success' : 'warning'">CONNECTED</b-button>
                <b-button v-else size="sm" @click="$emit('triggerModal', 'manageSource', content.cc, content.dc)" :variant="running ? 'success' : 'warning'">CONNECTED <b-badge v-if="filteredBookings.length > 1" variant="light">{{ filteredBookings.length }}</b-badge></b-button>
            </template>
        </template>
        <template v-else-if="showButt">
            <template v-if="content.isTag">
                <b-button size="sm" @click="$emit('triggerModal', content.cc.campaignId ? 'addCampaignToTag' : 'addSourceToTag', content.cc, content.dc)">
                    {{ content.cc.campaignId ? 'BOOK' : 'CONNECT' }}
                </b-button>
            </template>
            <template v-else>
                <template v-if="content.cc.campaignId">
                    <b-button size="sm" @click="$emit('triggerModal', 'addCampaign', content.cc, content.dc)">BOOK</b-button>
                </template>
                <template v-else>
                    <b-button size="sm" @click="$emit('triggerModal', 'addSource', content.cc, content.dc)">CONNECT</b-button>
                </template>
            </template>
        </template>
    </template>
</b-td>
</template>

<script>
// {{ booking.campaignId === content.cc.campaignId ? 'BOOKED' : '' }}
// grey out column if display prop is offline

import moment from 'moment'


export default {
    name: 'IpamCell',
    components: {
    },
    data () {
        return {
            loaded: false,
            showButt: false,
        }
    },
    props: {
        content: {
            type: Object,
            required: true,
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.loaded = true
        })
    },
    computed: {
        filteredBookings: function() {
            if (!this.loaded) return null
            if (this.content.isTag) {
                // tag mode: show BOOKED only if every display in this tag has a booking
                // that was booked via this specific tag (tagId matches).
                const displays = this.content.dc.displays
                if (displays.length === 0) return []
                const tagId = this.content.dc.tagId
                let allMatched = []
                for (let display of displays) {
                    let matched
                    if (this.content.cc.campaignId) {
                        matched = display.bookings.data.filter(
                            booking => booking.campaignId === this.content.cc.campaignId &&
                                       booking.tagId === tagId &&
                                       moment.tz(booking.endDate + ' ' + booking.endTime, display.timezone).local().format('YYYY-MM-DD') >= this.content.date
                        )
                    } else {
                        matched = display.e2vbookings.data.filter(
                            booking => booking.sourceId === this.content.cc.sourceId &&
                                       booking.tagId === tagId &&
                                       moment.tz(booking.endDate + ' ' + booking.endTime, display.timezone).local().format('YYYY-MM-DD') >= this.content.date
                        )
                    }
                    if (matched.length === 0) return []
                    allMatched = allMatched.concat(matched)
                }
                return allMatched
            }
            return this.content.dc.bookings.data.filter(
                booking => booking.campaignId === this.content.cc.campaignId && moment.tz(booking.endDate + ' ' + booking.endTime, this.content.dc.timezone).local().format('YYYY-MM-DD') >= this.content.date
            ).concat(this.content.dc.e2vbookings.data.filter(
                booking => booking.sourceId === this.content.cc.sourceId && moment.tz(booking.endDate + ' ' + booking.endTime, this.content.dc.timezone).local().format('YYYY-MM-DD') >= this.content.date)
            )
        },
        running: function() {
            if (!this.loaded) return null
            let displays = this.content.isTag ? this.content.dc.displays : [this.content.dc]
            let running = false
            for (let display of displays) {
                for (let booking of display.bookings.data) {
                    if (moment.tz(booking.endDate + ' ' + booking.endTime, display.timezone).local().format('YYYY-MM-DD') >= this.content.date && moment.tz(booking.startDate + ' ' + booking.startTime, display.timezone).local().format('YYYY-MM-DD') <= this.content.date)
                        if (moment.tz(booking.endDate + ' ' + booking.endTime, display.timezone).local().format('HH:mm:ss') >= this.content.time && moment.tz(booking.startDate + ' ' + booking.startTime, display.timezone).local().format('HH:mm:ss') <= this.content.time)
                            running = true
                }
            }
            return running
        }
    },
    watch: {
    },
    methods: {
        mouseOver() {
            this.showButt = true
        },
        mouseLeave() {
            this.showButt = false
        },
    }
}
</script>